import { SelectUser as UseCaseReduxSelectUser } from '~/domain/usecases/auth/redux';

import { ReduxSelectUser } from '~/data/store/reducer/auth/usecases/ReduxSelectUser';

/**
 * make login via SAGA.
 */
export const makeReduxSelectUser = (): UseCaseReduxSelectUser =>
  new ReduxSelectUser();
